export default {
  price: {
    id: 'customer_care_conversation_details_price',
    defaultMessage: 'Price: {price}',
  },
  grade: {
    id: 'sav_platform_list_grade_new',
    defaultMessage: 'Grade: {grade}',
  },
  imei: {
    id: 'sav_platform_list_imei_new',
    defaultMessage: 'IMEI: {imei}',
  },
  serialNumber: {
    id: 'sav_platform_list_serial_number',
    defaultMessage: 'Serial number: {serialNumber}',
  },
  quantity: {
    id: 'sav_platform_quantity_new',
    defaultMessage: 'Quantity: {quantity}',
  },
  salesTaxPrice: {
    id: 'sav_platform_salestax_price_new',
    defaultMessage: '{salesTaxPrice} taxes',
  },
  shippingPrice: {
    id: 'sav_platform_shipping_price_new',
    defaultMessage: 'Shipping cost {shippingPrice}',
  },
  sku: {
    id: 'sav_platform_sku_new',
    defaultMessage: 'SKU: {productLink, html}',
  },
  title: {
    id: 'sav_platform_product_info',
    defaultMessage: 'Product info',
  },
  yakuzaPhone: {
    id: 'sav_platform_yakuza_phone',
    defaultMessage: 'Japanese smartphone',
  },
  newBatteryDevice: {
    id: 'bo_agent_care_folder_details_panel_new_battery_device',
    defaultMessage: 'New battery purchased',
  },
}
